<template>
    <div id="OpportunityPageLayout">
        <div
            class="relative"
            :class="{
                'container': variant === 'job'
            }"
        >
            <CBackButton
                v-if="to && !preview && !minified"
                :fixed-top="!backLabel"
                :label="backLabel"
                :to="to"
            />
            <slot />
        </div>

        <div
            class="inline-block w-full"
            :class="{
                'bg-white dark:bg-surface-card pt-0 sm:pt-4': variant === 'job'
            }"
        >
            <div
                class="flex flex-col sm:mt-4 sm:gap-8"
                :class="{
                    'container': variant === 'job'
                }"
            >
                <div v-if="$slots.middle" :class="{ 'mb-8': variant === 'job' }">
                    <slot name="middle" />
                </div>

                <div
                    v-if="$slots.left || $slots.right"
                    class="grid-cols-12 gap-8"
                    :class="{
                        'sm:mb-8': !minified,
                        'grid ': variant !== 'job',
                        'mb-8 flex flex-col gap-15 sm:mb-15 lg:grid': variant === 'job'
                    }"
                >
                    <div
                        v-if="$slots.left"
                        :class="
                            minified
                                ? 'col-span-12'
                                : $slots.right
                                  ? reverseBottomStyle
                                      ? variant === 'job'
                                          ? 'col-span-12 lg:col-span-7 xl:col-span-7'
                                          : 'col-span-12 sm:col-span-7 lg:col-span-8 xl:col-span-9'
                                      : variant === 'job'
                                        ? 'col-span-12 lg:col-span-3 xl:col-span-2'
                                        : 'col-span-12 sm:col-span-5 lg:col-span-4 xl:col-span-3'
                                  : 'col-span-12'
                        "
                    >
                        <slot name="left" />
                    </div>

                    <div
                        :class="
                            minified
                                ? 'col-span-12'
                                : $slots.left
                                  ? reverseBottomStyle
                                      ? variant === 'job'
                                          ? 'col-span-12 lg:col-span-5 xl:col-span-5'
                                          : 'col-span-12 sm:col-span-5 lg:col-span-4 xl:col-span-3'
                                      : variant === 'job'
                                        ? 'col-span-12 lg:col-span-9 xl:col-span-10'
                                        : 'col-span-12 sm:col-span-7 lg:col-span-8 xl:col-span-9'
                                  : 'col-span-12 flex justify-end'
                        "
                    >
                        <slot name="right" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    variant?: 'job'
    to?: any
    backLabel?: string
    reverseBottomStyle?: boolean
    preview?: boolean
    minified?: boolean
}

defineProps<Props>()
</script>
